import { sendRequest, sendRequestBackEnd } from './rootApi';
import Api from "../constants/Api";
import HttpRequest from "./HttpRequest";

export const getCurrentCredit = async (params) => {
    return sendRequest("post", Api.getCurrentCredit, params);
}

export const dialerTokenRequest = async (params) => {
    return sendRequest("post", Api.dialerToken, params);
}

export const getContact = async (params) => {
    return sendRequest("post", Api.getContact, params);
}

export const getContactWithPagination = async (params) => {
    return sendRequest("post", Api.getContactWithpagination, params);
}

export const getVirtualNumber = async (params) => {
    return sendRequest("post", Api.getVirtualNumber, params);
}

export const getVirtualNumberFromTenant = async (params) => {
    return sendRequestBackEnd("get", Api.getVirtualNumberFromTenant, params);
}

export const callHangUp = async (params) => {
    return sendRequest("post", Api.callHangUp, params);
}
export const callCancelByCallSid = async (params) => {
    return sendRequest("post", Api.callCancelByCallSid, params);
}
export const callCompleteByCallSid = async (params) => {
    return sendRequest("post", Api.callCompleteByCallSid, params);
}

export const holdCurrentCall = async (params) => {
    return sendRequest("post", Api.holdCurrentCall, params);
}

export const addParticipant = async (params) => {
    return sendRequest("post", Api.addParticipant, params);
}

export const unHoldCallParticipant = async (params) => {
    return sendRequest("post", Api.unHoldParticipant, params);
}

export const sendErrorMessageToDevelopers = async (params) => {
    return sendRequest("post", Api.sendErrorNotification, params);
}

export const getDialerSettings = async (params) => {
    return sendRequest("post", Api.getDialerSettings, params);
}

export const endCallConference = async (params) => {
    return sendRequest("post", Api.endCallConference, params);
}

export const updateRecordStatus = async (params) => {
    return HttpRequest.post(Api.updateRecordStatus, params);
}

export const contactCallDispositionTenant = (params) => {
    return HttpRequest.post(Api.contactCallDispositionTenant, params);
}

export const getTagListTenant = (params) => {
    return HttpRequest.get(Api.getTagListTenant, params);
}

export const getCampaignListTenant = (params) => {
    return HttpRequest.get(Api.getCampaignListTenant, params);
}

export const getCallOutcomeListTenant = (params) => {
  return HttpRequest.get(Api.getCallOutcomeListTenant, params);
};

export const updateCallReview = (params) => {
    return HttpRequest.put(Api.callReview, params);
};